import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NAService } from './na.service';

@NgModule({ imports: [CommonModule,
        FormsModule], providers: [
        NAService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class NAModule {}